import client from './client'

export const productClick = ({ params: { product, userUniqueId }, config, pageContext, widgetContext }) => {
	// clerk product click should only be tracked if the widget context includes 'clerk'
	// or if the search page is using clerk as the search adapter
	const isClerkContext =
		widgetContext.includes('clerk') ||
		(pageContext.includes('search') &&
			config.catalog.search.externalSearch.enabled &&
			config.catalog.search.externalSearch.adapter === 'clerk')

	if (!isClerkContext) return

	try {
		client.post('click', {
			product: product.id,
			visitor: userUniqueId,
		})
	} catch (e) {
		console.error(e)
	}
}
